module.exports = __webpack_public_path__ + "img/index-s1.ef79b55c.png";